import { render, staticRenderFns } from "./epb-pill.component.vue?vue&type=template&id=d8b8fa02&scoped=true"
import script from "./epb-pill.component.vue?vue&type=script&lang=ts"
export * from "./epb-pill.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-pill.component.vue?vue&type=style&index=0&id=d8b8fa02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b8fa02",
  null
  
)

export default component.exports